function sma (period, prices) {
  return getLastItems(prices, period).reduce((a,b) => a + b) / period
}

function getLastItems(array, number) {
    return array.slice(array.length-number);
}

export default {
    getIndications: (rawQuotes, position) => {
        const maPeriod = 30;
        const buyMASlope = 0;
        const sellMASlope = -0.5;
        const usedPeriod = maPeriod;
        const middlePeriod = 8;
      
        if(rawQuotes.length < usedPeriod) return false;
      
        // Build simple indicators from X latest quotes
        const quotes = getLastItems(rawQuotes, usedPeriod);
      
        // TOHLCV
        const highs = quotes.map(d => d[2]);
        const lows = quotes.map(d => d[3]);
        const closes = quotes.map(d => d[4]);
        // MA
        const lma = sma(maPeriod, closes);
        const highs20 = getLastItems(highs, 8)
        const lows20 = getLastItems(lows, 8)
        // LMA
        const lmiddlema = sma(middlePeriod, closes);

        // High / Low
        let highest = Math.max.apply(Math, highs20);
        let lowest = Math.min.apply(Math, lows20);

        const sumCloses = closes.slice(1).reduce((a,b) => a+b);

        const buylma = lma*buyMASlope/100 + lma;
        const buyPrice = (buylma * maPeriod) - sumCloses;
        
        const selllma = lmiddlema*0/100 + lmiddlema;
        const sellPrice = (selllma * middlePeriod) - getLastItems(closes, middlePeriod).slice(1).reduce((a,b) => a+b);
      
        // no position
        let upper = Math.max(highest, buyPrice);
        if( position.bk) upper = Math.min(position.bk*0.997, upper);
        let lower = lowest;
        
        // in position
        if( position.bd ) {
          upper = highest;
          //console.log(position.st, position.st * 1.004, lowest*0.85, sellPrice)
          lower = Math.max(position.st * 1.004, lowest*0.85);
        }

        // Init phase 
        // if( rawQuotes.length == usedPeriod 
        //   && getLastItems(closes, 1) > buylma) {
        //     upper = buylma;
        // }

        return [quotes[quotes.length-1][0], upper, lower, lower];
      }
  }
  